import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { checkAndGetArray } from '../../common/helpers/array-helper';
import { IReceipt } from '../../common/interfaces/dtos/IReceipt';
import { CashOfficeMenuState } from '../../common/interfaces/states/CashOfficeMenuState';
import { store } from '../../common/redux/configure-store';
import { printReceipts } from '../../devices/printer-operations';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { closeDrawer } from '../components/cash-drawer-actions';
import { LoanAddRequest, AmountAndTender } from '../interfaces/LoanAddRequest';
import { postLoanAdd } from './services/post-loan-add';

export const processLoanAdd = async (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
): Promise<void> => {
  const loanAddRequest: LoanAddRequest = {
    workerId: store.getState().user.workerId ?? '',
    workstationId: store.getState().touchPoint.touchPointConfiguration.touchPointId ?? '',
    destination: store.getState().touchPoint.touchPointConfiguration.accountExternalId ?? '',
    amountAndTender: createTenderSummaryList(tenderMenuGroups),
  };

  await postLoanAdd(loanAddRequest)
    .then(
      async (receipts: IReceipt[]): Promise<void> => {
        if (receipts && receipts.length > 0) {
          await printReceipts(checkAndGetArray(receipts)).catch(popupMessage);
        }
        closeDrawer();
        await getTouchPointNotifications();
      },
    )
    .catch(err => {
      popupMessage(err);
    });
};

const createTenderSummaryList = (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
): AmountAndTender[] => {
  const tenderSummaryList: AmountAndTender[] = [];
  if (tenderMenuGroups.sellableTenders && tenderMenuGroups.sellableTenders?.tenderGroups) {
    tenderMenuGroups.sellableTenders?.tenderGroups.forEach(tenderGroup => {
      const tenderList = tenderGroup.tenderCountList || [];
      tenderList.forEach(tenderCountEntry => {
        const tenderSummary: AmountAndTender = {
          voided: false,
          tenderType: `Tender:${tenderCountEntry.tenderId}`,
          tenderTotal: tenderCountEntry.amount ?? 0,
          denomination: tenderCountEntry.denomination,
        };
        tenderSummaryList.push(tenderSummary);
      });
    });
  }

  return tenderSummaryList;
};
